import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Genome } from 'src/providers/genome/genome';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';

import { RoomModel } from 'src/models/to-do.model';

import { ConfirmPage, ConfirmPageParamsModel } from 'src/pages/confirm/confirm.component';

@Component({
    templateUrl: 'remove-room.html',
    standalone: false
})

export class ToDosRemoveRoomPage implements OnInit {

  room: RoomModel;
  errorMessage: string;
  isRemovingRoomFromAddress: boolean;
  isRightSideContent: boolean;

  
  boundDeleteRoom = this.deleteRoom.bind(this);

constructor(
    private genome: Genome,
    private modalCtrl: ModalController,
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage
  ) {}

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    const dialogParams = await this.storage.retrieve('dialog-params');
    this.rightSidePanelService.setDialogPageTitle('Remove Room');
    this.room = this.navCtrl.getParam('room') || dialogParams.room;
    this.isRemovingRoomFromAddress = this.navCtrl.getParam('isRemovingRoomFromAddress');
  }

  async deleteRoom() {
    const params: ConfirmPageParamsModel = {
      title: 'Delete Room?',
      body: 'This will delete the room from all To-Do lists. You will not be able to undo this action.',
      backText: 'Go Back',
      confirmText: 'Delete Room',
      confirmAction: this.confirmDeleteRoom.bind(this)
    }
    const confirmationModal = await this.modalCtrl.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: 'confirm-modal'
    });
    await confirmationModal.present();
  }

  async confirmDeleteRoom() {
    try {
      this.storage.delete('addresses');
      if (this.isRemovingRoomFromAddress) {
        const addressId = parseInt(localStorage.getItem('addressId'));
        await this.genome.deleteRoom(addressId, this.room.id);
        this.navCtrl.navigateForward(`edit-rooms/${addressId}`);
      } else {
        await this.storage.save('shouldReloadPageAfterClosingSideRail', true);
        this.rightSidePanelService.navigateTo('to-dos');
      }
      this.modalCtrl.dismiss();
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      throw err;
    }
  }
}
